import React from "react";
import PageComponent from "components/Page";

import Search from "components/Search";
import SelectDateRange from "components/SelectDateRange";
import Select from "components/Select";
import Button from "components/Button";
import ButtonIconSelect from "components/ButtonIconSelect";
import Table from "components/Table";
/*import SelectDoctor from "components/SelectDoctor";*/
import DetailDialog from "pages/tasks/components/DetailDialog";
import TransferDialog from "pages/tasks/components/TransferDialog";
import ResponsibleDialog from "pages/tasks/components/ResponsibleDialog";

import { ReactComponent as PinFillIcon } from 'icons/components/pinFill.svg';

import './index.less';
import './themes/default.less';

export default class Tasks extends PageComponent {

    constructor(props) {
        super(props);

        this.openIcon = {
            type: "icon",
            typeIcon: "stroke",
            name: "arrowDown",
            hideLabel: true,
            cantSort: true,
            size: "32px",
            click: this.openDetailDialog.bind(this)
        };

        this.tableMap = {
            openIcon: this.openIcon,
            fio: {
                label: "client.fio",
                onClick: this.openClient.bind(this),
                size: "150px",
                type: "rows",
                rows: ["client.lname, client.fname", "client.sname", { key: "client.phoneNumber", style: "text p2 second" },],
            },
            doctorId: {
                label: "client.doctor",
                size: "150px",
                type: "doctor",
                short: true
            },
            description: {
                label: "Планируемая дата приема",
                type: "rows",
                size: "120px",
                rows: [{ key: "targetDate", type: "date", format: "DD MMMM YYYY" }, { key: "visitReason.title", style: "text p2 second" },],
            },
            taskRemindId: {
                label: "Ответственный клиника",
                size: "120px",
                type: "rows",
                rows: [
                    {
                        key: "taskRemindId",
                        type: "employe",
                        short: true
                    }, {
                        key: "domainId",
                        style: "text p2 second",
                        type: "select",
                        store: "clinics",
                        nameKey: "name",
                    }
                ],
            },
            status: {
                label: "main.status",
                size: "100px",
                callback: this.renderStatusCell.bind(this),
            },
            comment: {
                label: "Коментарий",
                callback: this.renderCommentCell.bind(this),
            },
            actions1: {
                label: "main.actions",
                callback: this.renderActionCell.bind(this),
                hideLabel: true,
                size: "100px",
            },
            actions2: {
                label: "main.actions",
                callback: this.renderInCell.bind(this),
                hideLabel: true,
                size: "32px",
            },
        };

        this.tableMapCancelVis = {
            openIcon: this.openIcon,
            fio: {
                label: "client.fio",
                onClick: this.openClient.bind(this),
                size: "150px",
                type: "rows",
                rows: ["client.lname, client.fname", "client.sname", { key: "client.phoneNumber", style: "text p2 second" },],
            },
            doctorId: {
                label: "client.doctor",
                size: "150px",
                type: "doctor",
                short: true
            },
            beginDate: {
                label: "Дата назначения",
                size: "120px",
                type: "date",
                format: "DD MMMM YYYY",
            },
            changedTime: {
                label: "Дата отмены",
                type: "date",
                format: "DD MMMM YYYY",
            },
            consultantId: {
                label: "Ответственный клиника",
                type: "rows",
                size: "120px",
                rows: [
                    {
                        key: "consultantId",
                        type: "employe",
                        short: true
                    }, {
                        key: "domainId",
                        style: "text p2 second",
                        type: "select",
                        store: "clinics",
                        nameKey: "name"
                    }
                ],
            },
            comment2: {
                label: "main.status",
                size: "100px",
                callback: this.renderStatus2Cell.bind(this),
            },
            comment: {
                label: "Коментарий",
                callback: this.renderComment2Cell.bind(this),
            },
            actions1: {
                label: "main.actions",
                callback: this.renderActionCell.bind(this),
                hideLabel: true,
                size: "100px",
            },
            actions2: {
                label: "main.actions",
                callback: this.renderInCell.bind(this),
                hideLabel: true,
                size: "32px",
            },
        };

        const keys = Object.keys(this.tableMap);

        this.state = {
            ...this.state,
            items: [],
            itemsCancel: [],
            doctorId: false,
            searchDoctor: "",
            searchPacient: "",
            searchResp: "",
            selectedStartDate: new Date(),
            selectedEndDate: this._helper.date.addMonth(new Date(), 1),
            statusItems: [],
            reasonItems: [],
            filterCurrentStatus: 0,
            filterCurrentReason: 0,
            modePage: "showRepVisits",
            currentClinic: 1,
            clinicList: [{ id: 1, name: this.tr("report.allClinics") }]
        };

        this.selectItems = keys.map(key => {
            return { id: key, name: this.tr(this.tableMap[key].label) };
        });
    }

    componentDidLoad() {
        this.getVisit();
    }

    componentDidUpdate() {
        const { selectedStartDate, selectedEndDate } = this.state;
        if (this.selectDateRange)
            this.selectDateRange.setInputValue({ selectedStartDate, selectedEndDate, type: selectedEndDate ? 1 : 0 });
    }

    refresh() {
        this.getVisit();
    }

    get dialogsMap() {
        return {
            "detail": DetailDialog,
            "transfer": TransferDialog,
            "responsible": ResponsibleDialog,
        };
    }

    goToAppointment(info, domainId, targetDate) {
        const { id, fname, lname, sname, birthday, phoneNumber, photoUid } = info;
        const items = [{ id, fname, lname, sname, birthday, phoneNumber, photoUid }];
        const dateI = this._helper.date.toDateServerStr(new Date(targetDate));
        this._helper.storage("apptSelectedClients", { items, date: dateI });
        this._helper.storage("apptLastActiveClient", id);
        this._helper.openPage("appointment", { date: dateI, domainId, forClientId: id });
    }

    openDetailDialog(info) {
        const { modePage } = this.state;
        this._helper.openDialog("detail", info, modePage);
    }

    openTransferDialog(info) {
        this._helper.openDialog("transfer", info, this.updateRepeatedVisits.bind(this));
    }

    openTransferDialog2(info) {
        this._helper.openDialog("transfer", info, this.updateCanceledVisits.bind(this));
    }

    openResponsibleDialog(info, source) {
        this._helper.openDialog("responsible", info, this.updateResponsibleVisits.bind(this, source));
    }

    openClient(info) {
        const { id } = info.client;
        this._helper.openClient(id);
    }

    async updateRepeatedVisits(info) {
        const { id, comment, remindBefore } = info;
        await this._request.repeatedVisits.update(id, { comment, remindBefore, status: "TASK_POSTPONED" });
        this.getVisit();
    }

    async updateCanceledVisits(info) {
        const { id, comment, remindBefore } = info;
        const comment2 = JSON.stringify({ comment, remindBefore });
        await this._request.visits.update(id, { comment2 });
        this.getCancelVisits();
    }

    async updateResponsibleVisits(source, info) {
        const { id, consultantId } = info;
        this._helper.showLoading();
        if (source === "repVis") {
            await this._request.repeatedVisits.update(id, { taskRemindId: consultantId });
            this.getVisit();
        } else {
            await this._request.visits.update(id, { consultantId });
            this.getCancelVisits();
        }
        this._helper.hideLoading();
    }

    onClinicChanged() {
        const { modePage } = this.state;
        if (modePage === "showRepVisits") {
            this.getVisit();
        } else {
            this.getCancelVisits();
        }
    }

    async onCancelVisit(id) {
        this._helper.showLoading();
        await this._request.repeatedVisits.delete(id);
        this._helper.hideLoading();
        this.getVisit();
    }

    async onCancelRow(id) {
        this._helper.showLoading();
        await this._request.visits.update(id, { comment2: "deleted" });
        this._helper.hideLoading();
        this.getCancelVisits();
    }

    onForm(selectedRange) {
        const { modePage } = this.state;
        if (modePage === "showRepVisits") {
            this.setState(selectedRange, () => {
                this.getVisit();
            });
        } else {
            this.setState(selectedRange, () => {
                this.getCancelVisits();
            });
        }
    }

    cancelConfirm(id) {
        this._helper.confirm(
            { title: "Отмена приема", message: this.tr("Вы отменяете прием. Он пропадет из карты пациента - Подтвердить?") },
            this.onCancelVisit.bind(this, id)
        );
    }

    cancelConfirm2(id) {
        this._helper.confirm(
            { title: "Удаление записи", message: this.tr("Вы удаляете запись из списка - Подтвердить?") },
            this.onCancelRow.bind(this, id)
        );
    }

    async setStatus(id, src) {
        this._helper.showLoading();
        if (src === "rep") {
            await this._request.repeatedVisits.update(id, { status: "TASK_SCHEDULED" });
            this._helper.hideLoading();
            this.getVisit();
        } else {
            await this._request.visits.update(id, { comment2: "sheduled" });
            this.getCancelVisits();
            this._helper.hideLoading();
        }
    }

    async getVisit() {
        const { clinicId, selectedStartDate, selectedEndDate } = this.state;

        this._helper.showLoading();
        const resp = await this._request.repeatedVisits.getRepeatedVisitsFuture(clinicId, selectedStartDate, selectedEndDate);

        let items = (resp?.data || []);

        this._helper.hideLoading();

        items = items.map(it => {
            it.doctor = globalThis.appPageView.getDoctorById(it.doctorId);
            it.responsible = globalThis.appPageView.getDoctorById(it.taskRemindId);
            return it;
        });

        items = items.sort((a, b) => (new Date(a.targetDate) < new Date(b.targetDate)));

        const statusItems = ["Все", ...new Set(items.map(item => item.status))].map((name, id) => {
            return { name, id };
        });

        const reasonItems = ["Все", ...[...new Set(items.map(item => item.visitReason.title))].sort()].map((name, id) => {
            return { name, id };
        });

        const clinicList = [{
            id: 1,
            name: this.tr("report.allClinics")
        }];

        items.forEach(it => {
            if (!clinicList.some(clinic => clinic.id === it.domainId))
                clinicList.push({
                    id: it.domainId,
                    name: this._helper.getClinicNameById(it.domainId)
                });
        });

        this.setState({ items, statusItems, reasonItems, clinicList });
    }

    getFutureVisit(clientId, visitsOfClients) {
        let doctor = null;
        let date = null;

        visitsOfClients.forEach(it => {
            const { doctorId, beginDate, client } = it;
            if (clientId === client.id && new Date(beginDate) > new Date()) {
                doctor = doctorId;
                date = beginDate;
            }
        });
        return { doctor, date };
    }

    getlastVisit(clientId, visitsOfClients) {
        let date = null;

        for (let it of visitsOfClients) {
            const { beginDate, client } = it;
            if (clientId === client.id && new Date(beginDate) < new Date()) {
                date = beginDate;
                break;
            }
        }
        return date;
    }

    async getCancelVisits() {
        const { clinicId, selectedStartDate, selectedEndDate } = this.state;

        this._helper.showLoading();
        const resp = await this._request.visits.getCanceledVisits(clinicId, selectedStartDate, selectedEndDate);

        let itemsCancel = (resp?.data || []).filter(it => it.comment2 !== "deleted");

        this._helper.hideLoading();

        itemsCancel = itemsCancel.map(it => {
            it.doctor = globalThis.appPageView.getDoctorById(it.doctorId);
            it.responsible = globalThis.appPageView.getDoctorById(it.consultantId);
            return it;
        });

        this.setState({ itemsCancel });
    }

    onChangeView(mode) {
        this.changeState("modePage", mode);
        if (mode === "showRepVisits") {
            this.getVisit();
        } else {
            const selectedStartDate = this._helper.date.addDays(new Date(), -30);
            const selectedEndDate = this._helper.date.addDays(new Date(), 60);
            this.setState({ selectedStartDate, selectedEndDate }, () => {
                this.getCancelVisits();
            });
        }
    }

    renderStatusCell(value) {
        const { statusRepVisit } = this._config;

        const color = value === "TASK_CREATED" ? "#F1F5D8" : value === "TASK_POSTPONED" ? "#FFEBEC" : "#FBF2D5";

        return (<div className={`status text p1`} style={{ backgroundColor: color }}>
            {this.tr(statusRepVisit[value])}
        </div>);
    }

    renderStatus2Cell(value) {
        let status = "tasks.created";
        let color = "#F1F5D8";
        if (value && this._helper.string.isJSONString(value)) {
            status = "tasks.postponed";
            color = "#FFEBEC";
        } else if (value && value === "sheduled") {
            status = "tasks.sheduled";
            color = "#FBF2D5";
        }

        return (<div className={`status text p1`} style={{ backgroundColor: color }}>
            {this.tr(status)}
        </div>);
    }

    renderCommentCell(value, map, { remindBefore, status }) {
        return (status === "TASK_POSTPONED" ? <div className="flex col gap8">
            <div className="text p1">{`Звонок ${this._helper.date.toStr(remindBefore, "DD.MM.YYYY")}`}</div>
            <div className="text p2">{value}</div>
        </div> : <div></div>);
    }

    renderComment2Cell(value, map, { comment2 }) {
        if (comment2 && this._helper.string.isJSONString(comment2)) {
            const obj = JSON.parse(comment2);
            const { comment, remindBefore } = obj;

            return (<div className="flex col gap8">
                <div className="text p1">{`Звонок ${this._helper.date.toStr(remindBefore, "DD.MM.YYYY")}`}</div>
                <div className="text p2">{comment}</div>
            </div>);
        }
        return false;
    }

    renderFutureVisitCell(value) {
        const { doctor, date } = value;
        const doctorInfo = globalThis.appPageView.getDoctorById(doctor);

        return (doctor ? <div>
            <div>{this._helper.date.toStr(date, "DD.MM.YYYY")}</div>
            <div>{this._helper.string.formatFullName(doctorInfo, "short")}</div>
        </div> : <div></div>);
    }

    renderInCell(value, map, info) {
        const { modePage } = this.state;
        const { /*futureVisit,*/ id } = info;

        let actionsItems = [
            { name: "Отложить звонок", onClick: this.openTransferDialog.bind(this, info) },
            { name: "Отказ от визита", onClick: this.cancelConfirm.bind(this, id) },
            { name: "Записан", onClick: this.setStatus.bind(this, id, "rep") },
            { name: "Выбор ответственного", onClick: this.openResponsibleDialog.bind(this, info, "repVis") },
        ];

        if (modePage !== "showRepVisits") {
            actionsItems = [
                { name: "Отложить звонок", onClick: this.openTransferDialog2.bind(this, info) },
                { name: "В работу", onClick: null },
                { name: "Записан", onClick: this.setStatus.bind(this, id, "canc") },
                { name: "Удалить визит", onClick: this.cancelConfirm2.bind(this, id) },
                { name: "Выбор ответственного", onClick: this.openResponsibleDialog.bind(this, info, "cancVis") },
            ];
        }

        let showMenu = true;

        return (showMenu ? <ButtonIconSelect
            translate={true}
            items={actionsItems}
        /> : <div></div>);
    }

    renderActionCell(value, map, { client, domainId, targetDate }) {
        let showMenu = true;

        return (showMenu ? <Button
            type={"secondary"}
            size={"small"}
            label={"Записать"}
            active={true}
            onClick={this.goToAppointment.bind(this, client, domainId, targetDate)}
        /> : <div></div>);
    }

    renderItemMenu(text, pin, mode) {
        const { modePage } = this.state;
        return (<div
            className={`itemMenu flex gap8 ${modePage === mode ? "active" : ""}`}
            onClick={this.onChangeView.bind(this, mode)}>
            {pin && <PinFillIcon />}
            {text}
        </div>);
    }

    renderPanel(itemsFilter, statusItems) {
        const { reasonItems, filterCurrentReason, modePage, filterCurrentStatus,
            currentClinic, clinicList /*searchDoctor doctorId*/ } = this.state;

        return (<div className="wrapPanelTasks flex flex1 minH0 hidden">
            <div className="calendarZone flex col gap16 padding scrolling" style={{ width: "224px" }}>
                <div className="flex col gap8 text p1">
                    {this.renderItemMenu(
                        this.tr("client.returnVisits"),
                        true,
                        "showRepVisits"
                    )}
                    {this.renderItemMenu(
                        "Отмененные визиты",
                        false,
                        "showCancVisits"
                    )}
                </div>
                <div className="text p1SemiBold">Фильтр</div>
                <div className="flex col gap16">
                    <Select
                        value={currentClinic}
                        label={this.tr("login.clinic")}
                        showLeftIcon={false}
                        items={clinicList}
                        onChange={this.changeState.bind(this, "currentClinic")} />
                    <div className="flex gap8">
                        {modePage === "showRepVisits" ? <SelectDateRange
                            ref={el => this.selectDateRange = el}
                            onForm={this.onForm.bind(this)}
                            futureOff={false}
                            mode="future" />
                            : <SelectDateRange
                                ref={el => this.selectDateRange = el}
                                futureOff={false}
                                onForm={this.onForm.bind(this)} />}
                    </div>
                    <div className="flex gap8">
                        <Search
                            label="Врач"
                            itemStyle="search"
                            placeHolder={"Поиск врача"}
                            onChange={this.changeState.bind(this, "searchDoctor")}
                        />
                        {/*<SelectDoctor
                            value={doctorId}
                            label="client.doctor"
                            hide={true}
                            onClick={this.changeState.bind(this, "doctorId")}
                        />*/}
                    </div>
                    <div className="flex gap8">
                        <Search
                            label="Пациент"
                            itemStyle="search"
                            placeHolder={"Поиск пациента"}
                            onChange={this.changeState.bind(this, "searchPacient")}
                        />
                    </div>
                    <div className="flex gap8">
                        <Search
                            label="Ответственный"
                            itemStyle="search"
                            placeHolder={"Поиск по ответственному"}
                            onChange={this.changeState.bind(this, "searchResp")}
                        />
                    </div>
                    <div className="flex gap8">
                        <Select
                            items={statusItems}
                            value={filterCurrentStatus}
                            label="main.status"
                            showLeftIcon={false}
                            onChange={this.changeState.bind(this, "filterCurrentStatus")}
                        />
                    </div>
                    {modePage === "showRepVisits" && <div className="flex gap8">
                        <Select
                            items={reasonItems}
                            value={filterCurrentReason}
                            label="main.reason"
                            showLeftIcon={false}
                            onChange={this.changeState.bind(this, "filterCurrentReason")}
                        />
                    </div>}
                </div>
            </div>
            <div className="flex1 flex col padding">
                {modePage === "showRepVisits" ? <Table
                    map={this.tableMap}
                    items={itemsFilter}
                /> : <Table
                    map={this.tableMapCancelVis}
                    items={itemsFilter}
                />}
            </div>
        </div>);
    }

    renderPage() {
        const { items, itemsCancel, searchPacient, selectedStartDate, filterCurrentStatus, /*doctorId,*/
            selectedEndDate, reasonItems, filterCurrentReason, modePage, searchResp,
            searchDoctor, currentClinic } = this.state;

        const { statusRepVisit, statusCancVisit } = this._config;
        let statusItems = [];

        if (modePage === "showRepVisits") {
            statusItems = [{ name: "Все", id: 0 }, ...Object.keys(statusRepVisit).map(it => {
                return { name: this.tr(statusRepVisit[it]), id: it };
            })];
        } else {
            statusItems = [{ name: "Все", id: 0 }, ...Object.keys(statusCancVisit).map(it => {
                return { name: this.tr(statusCancVisit[it]), id: it };
            })];
        }

        let itemsFilter = modePage === "showRepVisits" ? items : itemsCancel;
        if (searchDoctor)
            itemsFilter = itemsFilter.filter(it => {
                const req = it.doctor.lname.toLowerCase().startsWith(searchDoctor.toLowerCase());
                return req;
            });

        if (currentClinic !== 1)
            itemsFilter = itemsFilter.filter(it => it.domainId === currentClinic);

        /*if (doctorId)
            itemsFilter = itemsFilter.filter(it => it.doctorId === doctorId);*/

        if (searchPacient) {
            const searchTerms = searchPacient.toLowerCase().split(' ');
            const check = (term, name) => (name.toLowerCase().startsWith(term));
            itemsFilter = itemsFilter.filter(it => {
                const { fname, lname, sname } = it?.client;
                return searchTerms.every(term => (check(term, fname) || check(term, lname) || check(term, sname)));
            });
        }

        if (searchResp)
            itemsFilter = itemsFilter.filter(it => {
                const req = it?.responsible?.lname?.toLowerCase().startsWith(searchResp?.toLowerCase());
                return req;
            });

        if (selectedStartDate) {
            const sed = selectedEndDate ? selectedEndDate.setHours(23, 59) : new Date(selectedStartDate).setHours(23, 59);

            itemsFilter = itemsFilter.filter(it => {
                const dt = modePage === "showRepVisits" ? it.targetDate : it.beginDate;
                const req = this._helper.date.dateInRange(dt, selectedStartDate, sed);
                return req;
            });
        }

        if (filterCurrentStatus) {
            if (modePage === "showRepVisits") {
                itemsFilter = itemsFilter.filter(it => {
                    const req = (it.status === filterCurrentStatus);
                    return req;
                });
            } else {
                itemsFilter = itemsFilter.filter(it => {
                    const st = it.comment2 && this._helper.string.isJSONString(it.comment2) ? 2 : it.comment2 === "sheduled" ? 3 : 1;
                    const req = (+st === +filterCurrentStatus);
                    return req;
                });
            }
        }

        if (filterCurrentReason) {
            const currentReason = reasonItems[filterCurrentReason].name;
            itemsFilter = itemsFilter.filter(it => {
                const req = (it.visitReason.title === currentReason);
                return req;
            });
        }

        itemsFilter = itemsFilter.sort((a, b) => new Date(a.targetDate) - new Date(b.targetDate));

        return (<div className="flex flex1 col" >
            <div className="flex between padding">
                <div className="text pageTitle">{this.tr("menu.tasks")}</div>
                <div className="flex gap16">
                    {/*<Search
                        itemStyle="search"
                        placeHolder={"Поиск задачи"}
                        onChange={null}
                    />
                    <Button
                        type={"primary"}
                        size={"small"}
                        label={"Новая задача"}
                        active={true}
                    />*/}
                    <div className="text p1">{`Количество визитов ${itemsFilter.length}`}</div>
                </div>
            </div>
            {this.renderPanel(itemsFilter, statusItems)}
        </div>);
    }
}

